/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const HideNoDeadlineEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('HIDE_NO_DEADLINE_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class HideNoDeadlineEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return HideNoDeadlineEnabledSettingParser.decode(input).map(res => new HideNoDeadlineEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return HideNoDeadlineEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return HideNoDeadlineEnabledSettingParser.encode(data);
    }
    static schema() {
        return HideNoDeadlineEnabledSettingParser.schema();
    }
}
